import { apiFetch } from './client';

export const getPublicSiteSettings = () =>
  apiFetch('/site-settings');

export const getPublicStats = () =>
  apiFetch('/public-stats');
